<template>
  <v-card
    :height="height"
    :width="width"
    :style="{ background: `${background} !important` }"
    :flat="flat == undefined || flat == false ? false : true"
    style="text-align: center; direction: ltr; position: relative"
    class="d-flex rounded-xl flex-column align-items-center justify-content-center"
  >
    <div class="d-flex flex-no-wrap justify-space-center align-items-center">
      <div>
        <v-card-subtitle
          style="width: 150px; height: 50px"
          class="pa-0 ma-0 text-center text-break"
          v-if="editName"
          :style="{ color: color }"
        >
          <v-text-field
            outlined
            height="15px"
            append-icon="mdi-close"
            prepend-inner-icon="mdi-check"
            width="150px"
            dense
            :disabled="loading"
            v-model="editNameText"
            :loading="loading"
            @click:prepend-inner="updateTitleName()"
            @click:append="editName = false"
          ></v-text-field>
        </v-card-subtitle>
        <v-card-subtitle
          :style="{
            color: color,
            width: '120px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }"
          v-else
          class="pa-2"
        >
          <v-icon
            v-if="link"
            :style="{ color: color }"
            @click="
              editName = true;
              editNameText = title;
            "
            size="15"
          >
            mdi-pencil
          </v-icon>
          {{ title }}
        </v-card-subtitle>

        <v-card-actions class="text-center d-flex justify-content-center">
          <v-btn
            icon
            class=""
            :color="color"
            @click.native="playing ? pause() : play()"
            v-if="loaded"
          >
            <v-icon v-if="!playing || paused">{{ playIcon }}</v-icon>
            <v-icon v-else>{{ pauseIcon }}</v-icon>
          </v-btn>
          <v-btn v-else icon @click.native="loaded ? download() : reload()">
            <v-icon>{{ refreshIcon }}</v-icon>
          </v-btn>

          <p
            :style="{
              color: color,
              width: '70%',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }"
            class="ma-0"
          >
            {{ persian(currentTime) }}
          </p>
        </v-card-actions>
        <div class="d-flex flex-row-reverse">
          <v-progress-linear
            v-model="percentage"
            ref="linery"
            height="5"
            :color="color ?? 'black'"
            @click.native="handleCircleClick"
            :disabled="!loaded"
            reverse
            class="ltr-progress"
          ></v-progress-linear>
        </div>
      </div>

      <v-avatar
        class="ma-3"
        size="125"
        tile
        style="position: relative; overflow: hidden"
      >
        <v-img
          height="120"
          width="100"
          class="rounded-xl"
          :src="imageCover ?? 'media/musicDefault.webp'"
        />
        <span
          :style="{
            position: 'absolute',
            width: '100%',
            height: '100%',
            borderRadius: '15px',
            background:
              background?.length > 9
                ? `linear-gradient(to top, ${background.slice(
                    background.length - 21,
                    9,
                  )}, transparent)`
                : `linear-gradient(to top, ${background}, transparent)`,
          }"
        >
        </span>
        <v-btn
          width="20"
          height="20"
          class="position-absolute"
          color="green"
          fab
          small
          elevation="0"
          v-if="editCover"
          @click="$emit('image', id)"
        >
          <v-icon color="white">mdi-plus</v-icon>
        </v-btn>
      </v-avatar>
    </div>

    <v-slider
      v-if="audioSound"
      v-model="playerVolume"
      :prepend-icon="volumeHighIcon"
      style="padding: 0 10rem"
      max="1"
      step="0.01"
      min="0"
    ></v-slider>
    <audio
      id="player"
      ref="player"
      v-on:ended="ended"
      v-on:canplay="canPlay"
      :src="file"
    ></audio>
  </v-card>
</template>
<script>
import { ir } from "../../../../../../check_domain_ir";
import { Bus } from "../../../../../../main";
import { parseBlob } from "music-metadata-browser";

const formatTime = (second) =>
  new Date(second * 1000).toISOString().substr(11, 8);

export default {
  name: "newPlayer2",
  props: {
    flat: {
      type: Boolean,
      default: false,
    },
    file: {
      type: String,
      default: null,
    },
    autoPlay: {
      type: Boolean,
      default: false,
    },
    ended: {
      type: Function,
      default: () => {},
    },
    canPlay: {
      type: Function,
      default: () => {},
    },
    color: {
      type: String,
      default: null,
    },
    downloadable: {
      type: Boolean,
      default: true,
    },
    playIcon: {
      type: String,
      default: "mdi-play",
    },
    pauseIcon: {
      type: String,
      default: "mdi-pause",
    },
    stopIcon: {
      type: String,
      default: "mdi-stop",
    },
    refreshIcon: {
      type: String,
      default: "mdi-refresh",
    },
    downloadIcon: {
      type: String,
      default: "mdi-download",
    },
    volumeHighIcon: {
      type: String,
      default: "mdi-volume-high",
    },
    volumeMuteIcon: {
      type: String,
      default: "mdi-volume-mute",
    },
    audioSound: {
      type: Boolean,
      default: false,
    },
    height: {
      type: [Number, String],
      default: "200",
    },
    width: {
      type: [Number, String],
      default: "100%",
    },
    title: String,
    id: [String, Number],
    link: {
      type: Boolean,
      default: true,
    },
    editCover: {
      type: Boolean,
      default: false,
    },
    background: {
      type: String,
      default: "white",
    },
    image: {
      type: String,
      default: null,
    },
  },

  watch: {
    image: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val) {
          this.imageCover = val;
        }
      },
    },
    background(val) {
      console.log(val);
    },
  },

  computed: {
    duration: function () {
      return this.audio ? formatTime(this.totalDuration) : "";
    },
  },

  data() {
    return {
      firstPlay: true,
      isMuted: false,
      loaded: false,
      playing: false,
      paused: false,
      percentage: 0,
      currentTime: "00:00:00",
      audio: undefined,
      totalDuration: 0,
      playerVolume: 1,
      editName: false,
      editNameText: "",
      url: process.env.VUE_APP_ROBOT,
      loading: false,
      imageCover: null,
      value: 1,
    };
  },

  methods: {
    // covers
    async extractCover(blob) {
      this.loading = true;

      try {
        const metadata = await parseBlob(blob);
        const picture = metadata.common.picture?.[0];
        if (picture) {
          const coverBlob = new Blob([picture.data], { type: picture.format });
          this.imageCover = URL.createObjectURL(coverBlob);
        } else {
          this.imageCover = null;
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    async handleUrl() {
      if (!!this.image) return;
      this.loading = true;

      try {
        const response = await fetch(this.file);
        if (!response.ok) throw new Error("دانلود ناموفق");

        const blob = await response.blob();
        await this.extractCover(blob);
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },

    isIOS() {
      return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    },

    handleCircleClick(e) {
      const bar = this.$refs.linery?.$el;
      const rect = bar.getBoundingClientRect();
      const clickX = e.clientX - rect.left;
      let percent = (clickX / rect.width) * 100;
      percent = Math.max(0, Math.min(100, percent));

      this.percentage = Math.round(percent);
      this.setPosition(this.percentage);
    },

    setPosition(e) {
      this.audio.currentTime = parseInt(
        (this.audio.duration / 100) * this.percentage,
      );
    },
    stop() {
      this.audio.pause();
      this.paused = true;
      this.playing = false;
      this.audio.currentTime = 0;
    },
    play() {
      if (this.playing) return;
      this.audio.play().then((_) => (this.playing = true));
      this.paused = false;
    },
    pause() {
      this.paused = !this.paused;
      this.playing = !this.playing;
      this.paused ? this.audio.pause() : this.audio.play();
    },
    download() {
      this.audio.pause();
      window.open(this.file, "download");
    },
    mute() {
      this.isMuted = !this.isMuted;
      this.audio.muted = this.isMuted;
    },
    reload() {
      this.audio.load();
    },
    _handleLoaded: function () {
      if (this.audio.readyState >= 2) {
        if (this.audio.duration === Infinity) {
          this.audio.currentTime = 1e101;
          this.audio.ontimeupdate = () => {
            this.audio.ontimeupdate = () => {};
            this.audio.currentTime = 0;
            this.totalDuration = parseInt(this.audio.duration);
            this.loaded = true;
          };
        } else {
          this.totalDuration = parseInt(this.audio.duration);
          this.loaded = true;
        }

        if (this.autoPlay) this.audio.play();
      } else {
        throw new Error("Failed to load sound file");
      }
    },
    _handlePlayingUI: function (e) {
      this.audio.volume = this.playerVolume;
      this.percentage = (this.audio.currentTime / this.audio.duration) * 100;
      this.currentTime = formatTime(this.audio.currentTime);
      this.playing = true;
    },
    _handlePlayPause: function (e) {
      if (e.type === "play" && this.firstPlay) {
        this.audio.currentTime = 0;
        if (this.firstPlay) {
          this.firstPlay = false;
        }
      }
      if (
        e.type === "pause" &&
        this.paused === false &&
        this.playing === false
      ) {
        this.currentTime = "00:00:00";
      }
    },
    _handleEnded() {
      this.paused = this.playing = false;
    },
    init: function () {
      this.audio.addEventListener("timeupdate", this._handlePlayingUI);
      this.audio.addEventListener("loadeddata", this._handleLoaded);
      this.audio.addEventListener("pause", this._handlePlayPause);
      this.audio.addEventListener("play", this._handlePlayPause);
      this.audio.addEventListener("ended", this._handleEnded);
    },

    updateTitleName() {
      if (this.link) {
        this.loading = true;
        const local_url = ir(this.url);
        this.$api
          .put(`${local_url}/files/update/${this.id}`, {
            title: this.editNameText,
          })
          .then((data) => {
            this.$toast.success(this.$t("successfully_completed"));
            this.editNameText = "";
            this.editName = false;
            Bus.$emit("updateList", true);
          })
          .catch((err) => {
            this.$toast.error(this.$t("problem_occurred"));
          })
          .finally(() => (this.loading = false));
      } else {
        try {
          this.$emit("click", { id: this.id, title: this.editNameText });
          this.$toast.success(this.$t("successfully_completed"));
          this.editNameText = "";
          this.editName = false;
        } catch {
          this.$toast.error(this.$t("problem_occurred"));
        } finally {
          this.loading = false;
        }
      }
    },
  },
  mounted() {
    this.audio = this.$refs.player;
    this.handleUrl();
    if (this.isIOS()) {
      this.reload();
    } else {
      console.log("android");
    }
    this.init();
  },
  beforeDestroy() {
    this.audio.removeEventListener("timeupdate", this._handlePlayingUI);
    this.audio.removeEventListener("loadeddata", this._handleLoaded);
    this.audio.removeEventListener("pause", this._handlePlayPause);
    this.audio.removeEventListener("play", this._handlePlayPause);
    this.audio.removeEventListener("ended", this._handleEnded);
  },
};
</script>

<style scoped>
.ltr-progress .v-progress-linear__bar {
  left: 0 !important;
  right: auto !important;
  direction: ltr !important
  ;
}

.ltr-progress .v-progress-linear--reverse .v-progress-linear__determinate {
  left: 0 !important;
  right: auto !important;
}
.no-shadow {
  box-shadow: none !important;
}

.no-hover .v-btn:hover {
  background-color: transparent !important;
  box-shadow: none !important;
}

.responsive-width {
  width: 100% !important;
  max-width: 600px;
  margin: auto;
}
.shadows {
  box-shadow: inset 0px 6px 12px rgba(0, 0, 0, 0.4),
    inset 0px -6px 12px rgba(80, 80, 80, 0.25) !important;
}
</style>
